export const AppColors = {
  onboardingBackgroundColor: '#E0EDFF',
  lightThemeScaffoldBackgroundColor: '#F1F3F8',
  lightThemeScaffoldBackgroundColorLittleDark: '#E5E5E5',
  primary: '#3085FE',
  textSecondary: '#9E9E9E',
  ivory: '#FFFBF5',
  darkGreen: '#003434',
  turquoise: '#178C8C',
  white: '#FFFFFF',
  offWhite: '#F9FAFB',
  whiteDark: '#868686',
  red: '#FF0000',
  darkRed: '#B00000',
  lightRed: '#FF6B6B',
  darkOrange: '#FF6B00',
  lightOrange: '#FFD600',
  black: '#000000',
  forestGreen: '#005A5A',
  teal: '#12ADAD',
  teal2: '#1296AD',
  teal3: '#12AD96',
  darkgray: '#2C2C2C',
  lightGray: '#E5E5E5',
  gold: '#E6EB00',
  yellow: '#FFB800',
  green: '#0C9100',
  gray: '#D9D9D9',
  grayWhite: '#CDCDCD',
  grayWhite2: '#D0D0D0',
  lead: '#EBEBEB',
  foshia: '#FFDDDD',
  linear1: '#474747',
  linear2: '#000000',
  splashtext: '#DCD100',
  grey: '#979797',
  textYellow: '#CFC80A',
  buttonLinear1: '#CBC100',
  buttonLinear2: '#B49063',
  homeContainerBorder: '#D4D900',
  homeContainerFill: '#F2F4E5',
  unClickableButton: '#D3D3D3',
  notSelectedDots: '#A1A1A1',
  stroke: '#4C4C4C',
  sortIcon: '#EFEFEF',
  promoContent: '#F7F7F7',
  promoBorder: '#E6E6E6',
  promoText: '#0A8100',
  newColor: '#B49063',
  lastColor: '#B49063',
  kindaBlue: '#4A6FA5',
};

export const lightTheme = {
  ...AppColors,
  background: AppColors.lightThemeScaffoldBackgroundColor,
  surface: AppColors.white,
  text: '#111827',
  lightText: '#9ca3af',
  secondaryText: AppColors.textSecondary,
  primary: AppColors.primary,
  border: AppColors.lightThemeScaffoldBackgroundColorLittleDark,
  error: AppColors.darkRed,
  success: AppColors.green,
  warning: AppColors.darkOrange,
  muted: AppColors.grey,
};

export const darkTheme = {
  ...AppColors,
  background: '#0F172A',
  surface: '#111827',
  text: '#F8FAFC',
  lightText: '#94A3B8',
  secondaryText: '#94A3B8',
  primary: '#60A5FA',
  border: '#334155',
  error: AppColors.darkRed,
  success: AppColors.green,
  warning: AppColors.darkOrange,
  muted: '#94A3B8',
};
